import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { SwitchLabeled } from '@ui/actions'
import { useControlStore } from '@editorStores'

/**
 * "IFC transparent" and "IFC ausblenden" toggles for the IFC import Tools section. Laid out side by
 * side when there's room, wrapping to separate lines only once the container gets too narrow.
 */
const IFCTransparencyVisibilitySwitches = (): ReactElement => {
  const gltfModelTranslucent = useControlStore(state => state.gltfModelTranslucent)
  const setGltfModelTranslucent = useControlStore(state => state.setGltfModelTranslucent)
  const showGltfModel = useControlStore(state => state.showGltfModel)
  const setShowGltfModel = useControlStore(state => state.setShowGltfModel)

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      <SwitchLabeled
        checked={gltfModelTranslucent}
        onChange={event => setGltfModelTranslucent(event.target.checked)}
        label="IFC transparent"
        disabled={!showGltfModel}
        data-cy="switch-ifc-tools-transparent"
      />
      <SwitchLabeled
        checked={!showGltfModel}
        onChange={event => setShowGltfModel(!event.target.checked)}
        label="IFC ausblenden"
        data-cy="switch-ifc-tools-hide"
      />
    </Box>
  )
}

export default IFCTransparencyVisibilitySwitches
